import { UIFeatureCard } from '@/shared/ui/feature-card'

import { SERVICE_GTM_IDS, SERVICE_YA_METRICS_IDS } from './analitycs'

export const featureCards = (openFormCallback?: () => void): UIFeatureCard[] => [
	{
		icon: 'IPortService',
		heading: 'Гарантийный ремонт',
		text: (
			<>
				В&nbsp;течение 2 лет обслуживаем по&nbsp;гарантии всю технику, приобретённую в&nbsp;iPort. В&nbsp;ряде случаев
				принимаем и&nbsp;другую оригинальную продукцию Apple в&nbsp;рамках гарантии производителя.
			</>
		),
		actionHref: '/service/warranty-repair/'
	},
	{
		icon: 'IPortClock',
		heading: `Экспресс-ремонт`,
		text: (
			<>
				Заменим аккумулятор или дисплей за&nbsp;2 часа&nbsp;&mdash; при наличии запасной части для вашего устройства
				в&nbsp;сервисном центре
			</>
		),
		actionLabel: 'Записаться в сервис',
		actionOnClick: openFormCallback,
		actionElementClasses: [SERVICE_GTM_IDS.expressRepair, SERVICE_YA_METRICS_IDS.expressRepair]
	},
	{
		icon: 'IPortTradeIn',
		heading: <>Продажа техники из обмена в Трейд-ин</>,
		text: (
			<>
				Покупайте устройства, сданные по обмену в Трейд-ин, по&nbsp;выгодным ценам, вся техника проверена и&nbsp;готова
				к&nbsp;работе
			</>
		),
		actionHref: '/discount/'
	},
	{
		icon: 'IPortDiscount',
		heading: 'Выкуп устройств',
		text: (
			<>
				Сдайте старое устройство и&nbsp;получите за&nbsp;него деньги или выгоду на&nbsp;покупку новой техники
				в&nbsp;магазинах и&nbsp;сервисных центрах iPort
			</>
		),
		actionHref: '/service/purchase-of-devices/'
	},
	{
		icon: 'IPortPolicy',
		heading: <>Ремонт по страховому полису</>,
		text: <>Обслуживаем технику по полисам ВСК, Альфастрахование и программам iPort.</>,
		actionLabel: 'Узнать подробнее',
		actionHref: '/service/insurance/'
	}
]
